import { render, staticRenderFns } from "./noticedocument.vue?vue&type=template&id=58cf46d6&scoped=true"
import script from "./noticedocument.vue?vue&type=script&lang=js"
export * from "./noticedocument.vue?vue&type=script&lang=js"
import style0 from "./noticedocument.vue?vue&type=style&index=0&id=58cf46d6&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cf46d6",
  null
  
)

export default component.exports